import {
  ChangeDetectorRef,
  ElementRef,
  Component,
  OnDestroy,
  OnInit,
} from "@angular/core";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { Location } from "@angular/common";
import { Subject, forkJoin } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { AppService } from "src/app/app.service";
interface Image {
  src: string;
  thumbnail: string;
  alt: string;
}
@Component({
  selector: 'app-facilities',
  templateUrl: './facilities.component.html',
  styleUrls: ['./facilities.component.scss'],
})
export class facilities implements OnInit, OnDestroy {
  selectedItem: string = "";
  items = [
      { Name: "Library", Url: "library" },
      { Name: "Computer Lab", Url: "computer-lab" },
      { Name: "Play Ground", Url: "playground" },
      { Name: "Canteen", Url: "canteen" },
      { Name: "Transport", Url: "transport" },
      { Name: "MultipurposeShed", Url: "multipurposeShed" },
      { Name: "In Door Games", Url: "inDoorGames" },
      { Name: "TailorShop", Url: "TailorShop" },
      { Name: "Garden And Nursery", Url: "gardenAndNursery" },
      { Name: "Vegetable And Fish Market", Url: "vegetableAndFishMarket" },
      { Name: "Fish Aquarium", Url: "FishAquarium" },
      { Name: "Modern Class Room", Url: "modernClassroom" },
      { Name: "Others", Url: "others" },
  ];
  english23: Image[] = [
      {
          src: "assets/img/school/clubs/1.jpg",
          thumbnail: "assets/img/school/clubs/1.jpg",
          alt: "Image 01",
      },
      {
          src: "assets/img/school/clubs/2.jpg",
          thumbnail: "assets/img/school/clubs/2.jpg",
          alt: "Image 02",
      },
      {
          src: "assets/img/school/clubs/3.jpg",
          thumbnail: "assets/img/school/clubs/3.jpg",
          alt: "Image 03",
      },
  ];
  english22: Image[] = [
      {
          src: "assets/img/school/clubs/4.jpg",
          thumbnail: "assets/img/school/clubs/4.jpg",
          alt: "Image 01",
      },
      {
          src: "assets/img/school/clubs/5.jpg",
          thumbnail: "assets/img/school/clubs/5.jpg",
          alt: "Image 02",
      },
      {
          src: "assets/img/school/clubs/6.jpg",
          thumbnail: "assets/img/school/clubs/6.jpg",
          alt: "Image 03",
      },
  ];
  imageLoaded = false;
  fetchinData = true;
  ImageAlbums: any;
  GBs: any;
  GBs1: any;
  GBs2: any;
  TeacherInfo: any;
  GBms: any;
  GBms1: any;
  selectedItemName = "";
  showFullContent = false;
  showFullOverview = false;
  showFullWhy = false;
  showFullIns = false;
  showFullBuilding = false;
  showFullCulture = false;
  private ngUnsubscribe = new Subject();
  AboutUs: any;
  mission_data: any;
  vision_data: any;
  news: any;
  why_std: any;
  infus: any;
  histry: any;
  at_a_glance: any;
  oath_data: any;
  achievements: any;
  quiz_data: any;
  it_data: any;
  library_data: any;
  computer_lab_data: any;
  playground_data: any;
  canteen_data: any;
  transport_data: any;
  multipurposeShed_data: any;
  inDoorGames_data: any;
  TailorShop_data: any;
  gardenAndNursery_data: any;
  vegetableAndFishMarket_data: any;
  FishAquarium_data: any;
  modernClassroom_data:any;
  others_data: any;
  showMe: boolean = false;
  activeSection: string | null = null;
  constructor(
      private route: ActivatedRoute,
      private location: Location,
      private appService: AppService,
      private router: Router,
      private _changeDetectorRef: ChangeDetectorRef
  ) {}
  ngOnInit() {
      this.route.paramMap.subscribe((params: ParamMap) => {
          const item = params.get("item");
          const matchedItem = this.items.find((i) => i.Url === item);
          if (item && matchedItem && item == matchedItem.Url) {
              this.selectedItem = item;
              this.selectedItemName = matchedItem.Name;
          } else {
              this.selectedItem = this.items[0].Url;
              this.selectedItemName = this.items[0].Name;
              this.location.replaceState(`/${this.selectedItem}`);
          }
          this.FetchData();
      });
  }
  ngOnDestroy() {
      this.ngUnsubscribe.next(null);
      this.ngUnsubscribe.complete();
  }
  toggleMe(section: string) {
      this.activeSection = this.activeSection === section ? null : section;
  }
  FetchData() {
      this._changeDetectorRef.markForCheck();
      this.fetchinData = true;
      if (
          this.selectedItem === "library" ||
          this.selectedItem === "computer-lab" ||
          this.selectedItem === "playground" ||
          this.selectedItem === "canteen" ||
          this.selectedItem === "transport" ||
          this.selectedItem === "multipurposeShed" ||
          this.selectedItem === "inDoorGames" ||
          this.selectedItem === "TailorShop" ||
          this.selectedItem === "gardenAndNursery" ||
          this.selectedItem === "vegetableAndFishMarket" ||
          this.selectedItem === "FishAquarium" ||
          this.selectedItem === "modernClassroom" ||
          this.selectedItem === "others"
      ) {
          this.About_data();
      }
  }

  About_data() {
      forkJoin([this.appService.getContents()])
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe((response: any) => {
              console.log(response, "All Response For About Us");

              this.AboutUs = response[0].data;

              if (this.AboutUs != null) {
                  // Culture club
                  let library = this.AboutUs.filter(
                      (x) => x.ContentCategoryName == "Library"
                  );
                  this.library_data = library[0];
                  console.log(this.library_data, "library Data");
                  // knowledge-fiesta-club
                  let computer_data = this.AboutUs.filter(
                      (x) => x.ContentCategoryName == "Computer Lab"
                  );
                  this.computer_lab_data = computer_data[0];
                  console.log(
                      this.computer_lab_data,
                      "computer_lab_data"
                  );
                  // debate-club
                  let playground = this.AboutUs.filter(
                      (x) => x.ContentCategoryName == "Playground"
                  );
                  this.playground_data = playground[0];
                  console.log(this.playground_data, "playground_data");
                  
                  // chess - club;
                  let canteen = this.AboutUs.filter(
                      (x) => x.ContentCategoryName == "Canteen"
                  );
                  this.canteen_data = canteen[0];
                  console.log(this.canteen_data, "canteen_data");
                  // Art - club;
                  let transport = this.AboutUs.filter(
                      (x) => x.ContentCategoryName == "Transport"
                  );
                  this.transport_data = transport[0];
                  console.log(this.transport_data, "transport_data");
                  // ecology-club;
                  let multipurposeShed= this.AboutUs.filter(
                      (x) => x.ContentCategoryName == " Multipurpose Shed"
                  );
                  this.multipurposeShed_data = multipurposeShed[0];
                  console.log(this.multipurposeShed_data, "multipurposeShed_data");
                  // art_handwriting_club;
                  let inDoorGames = this.AboutUs.filter(
                      (x) => x.ContentCategoryName == "In Door Games"
                  );
                  this.inDoorGames_data = inDoorGames[0];
                  console.log(
                      this.inDoorGames_data,
                      "inDoorGames"
                  );
                  // science - club;
                  let TailorShop = this.AboutUs.filter(
                      (x) => x.ContentCategoryName == "Tailor Shop"
                  );
                  this.TailorShop_data = TailorShop[0];
                  console.log(this.TailorShop_data, "TailorShop_data");
                  // math-club;
                  let gardenAndNursery = this.AboutUs.filter(
                      (x) => x.ContentCategoryName == "Garden And Nursery"
                  );
                  this.gardenAndNursery_data = gardenAndNursery[0];
                  console.log(this.gardenAndNursery_data, "gardenAndNursery_data");
                  // Sports club
                  let vegetableAndFishMarket = this.AboutUs.filter(
                      (x) => x.ContentCategoryName == "Vegetable And Fish Market"
                  );
                  this.vegetableAndFishMarket_data = vegetableAndFishMarket[0];
                  console.log(this.vegetableAndFishMarket_data, "vegetableAndFishMarket_data");
                  // Ycs club
                  let FishAquarium = this.AboutUs.filter(
                      (x) => x.ContentCategoryName == "Fish Aquarium"
                  );
                  this.FishAquarium_data = FishAquarium[0];
                  console.log(this.FishAquarium_data, "FishAquarium_data");
                 //Scout club Data 
                  let modernClassroom = this.AboutUs.filter(
                      (x) => x.ContentCategoryName == "Modern Classroom"
                  );
                  this.modernClassroom_data = modernClassroom[0];
                  console.log(this.modernClassroom_data, "modernClassroom_data");
                  // English club
                  let others= this.AboutUs.filter(
                      (x) => x.ContentCategoryName == "others"
                  );
                  this.others_data = others[0];
                  console.log(this.others_data, "others_data");
              }

              this.fetchinData = false;
          });
  }
  selectItem(item: string) {
      this.selectedItem = item;
      const matchedItem = this.items.find((i) => i.Url === item);
      this.selectedItemName = matchedItem.Name;
      if (this.selectedItem === "library") {
          this.location.go(`/facilities/${item}`);
      } else if (this.selectedItem === "computer-lab") {
          this.location.go(`/facilities/${item}`);
      } else if (this.selectedItem === "playground") {
          this.location.go(`/facilities/${item}`);
      } else if (this.selectedItem === "canteen") {
          this.location.go(`/facilities/${item}`);
      } else if (this.selectedItem === "transport") {
          this.location.go(`/facilities/${item}`);
      } else if (this.selectedItem === "multipurposeShed") {
          this.location.go(`/facilities/${item}`);
      } else if (this.selectedItem === "inDoorGames") {
          this.location.go(`/facilities/${item}`);
      } else if (this.selectedItem === "TailorShop") {
          this.location.go(`/facilities/${item}`);
      } else if (this.selectedItem === "gardenAndNursery") {
          this.location.go(`/clubs/${item}`);
      } else if (this.selectedItem === "vegetableAndFishMarket") {
          this.location.go(`/facilities/${item}`);
      } else if (this.selectedItem === "FishAquarium") {
          this.location.go(`/facilities/${item}`);
      } else if (this.selectedItem === "modernClassroom") {
          this.location.go(`/facilities/${item}`);
      } else {
          this.location.go(`/facilities/others`);
      }
  }
  TransformUrl(value) {
      if (value.includes("https://")) {
          return value;
      } else {
          return `https://${value}`;
      }
  }
}
